import React from 'react'

const PhoneCall = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 30 30">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h30v30H0z" />
        <g transform="translate(7 2)" stroke="#000" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14.733 3.467V1.733C14.733.776 13.957 0 13 0H1.733C.776 0 0 .776 0 1.733v22.534C0 25.224.776 26 1.733 26H13c.957 0 1.733-.776 1.733-1.733v-6.934m0 2.6H0" stroke-width="1.5" />
          <circle stroke-width="1.5" cx="7.367" cy="22.967" r="1" />
          <path d="M13.59 12.965c.19.139.502.312.45.728-.052.416-.676 1.474-1.993 1.474-1.318 0-2.947-1.04-4.368-2.462C6.257 11.284 5.2 9.655 5.2 8.32s1.179-1.941 1.473-1.993c.295-.052.59.26.728.45l1.006 1.526a.71.71 0 0 1-.191.97c-.433.347-1.144.78.485 2.392 1.63 1.612 2.046.919 2.392.486a.71.71 0 0 1 .971-.191l1.525 1.005zM10.053 4.767a5.547 5.547 0 0 1 5.547 5.546M10.053 6.5a3.813 3.813 0 0 1 3.814 3.813m-3.814-1.906c1.053 0 1.907.853 1.907 1.906" />
        </g>
      </g>
    </svg>
    )
}

export default PhoneCall

